import { PlanType, RoleType } from "kmstack-shared/core";
import { Navigate } from "react-router-dom";
import { Suspense } from "react";
import LoadingSpinner from "@/components/LoadingSpinner";
import { hasAnyFeature, FeatureFlagType } from 'kmstack-shared/apps/accounting';

interface ProtectedRouteProps {
    userRole: RoleType | null;
    allowedRoles: RoleType[];
    userPlan?: PlanType;
    requiredFeatures?: readonly FeatureFlagType[];
    children: React.ReactNode;
}

export function ProtectedRoute({ userRole, allowedRoles, userPlan, requiredFeatures, children }: ProtectedRouteProps) {
    if (!userRole || !allowedRoles.includes(userRole)) {
        return <Navigate to="/unauthorized" replace />;
    }

    if (requiredFeatures?.length && !hasAnyFeature(userPlan ?? PlanType.FREE, requiredFeatures, userRole)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return (
        <Suspense fallback={<RouteLoader />}>
			<div style={{ height: '100%'}}>{children}</div>
		</Suspense>
    )
}

// Loading fallback component
const RouteLoader = () => (
    <div className="flex justify-center items-center h-screen">
        <LoadingSpinner />
    </div>
);
